import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useState } from 'react';
import { selectIsDisabled } from '@/entities/session';
import { useAppSelector } from '@/shared/model';
import { Panel } from '@/shared/ui';
import { HelpItem } from '../HelpItem/HelpItem';
import { Logo } from '../Logo/Logo';
import { NavigationList } from '../NavigationList/NavigationList';
import { OrganizationItem } from '../OrganizationItem/OrganizationItem';
import { ProfileItem } from '../ProfileItem/ProfileItem';

const NavigationPanel = styled('nav')(() => ({
  width: 56,
  minWidth: 56,
  position: 'relative',
}));

export function NavigationDrawer() {
  const isUserDisabled = useAppSelector(selectIsDisabled);
  const [openTimeoutId, setOpenTimeoutId] = useState<NodeJS.Timeout | null>(
    null,
  );
  const [expanded, setExpanded] = useState(false);

  const handlePanelOpen = () => {
    if (openTimeoutId) {
      clearTimeout(openTimeoutId);
    }

    setOpenTimeoutId(
      setTimeout(() => {
        setExpanded(true);
      }, 200),
    );
  };
  const handlePanelClose = () => {
    if (openTimeoutId) {
      clearTimeout(openTimeoutId);
    }
    setExpanded(false);
  };

  return (
    <NavigationPanel>
      <Panel
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          bottom: 0,
          width: '100%',
          transition: 'width 0.2s ease-in-out',
          zIndex: 1301,
          boxShadow: '0px 2px 6px 0px rgba(50, 50, 71, 0.16)',
          display: 'flex',
          flexDirection: 'column',

          ...(expanded && {
            width: 285,
          }),
        }}
        onMouseEnter={handlePanelOpen}
        onMouseLeave={handlePanelClose}
        onClick={(event) => {
          const currentMouseCoordinates = [event.clientX, event.clientY];
          const drawerRect = event.currentTarget.getBoundingClientRect();
          const isInsideDrawer =
            currentMouseCoordinates[0] >= drawerRect.left &&
            currentMouseCoordinates[0] <= drawerRect.right &&
            currentMouseCoordinates[1] >= drawerRect.top &&
            currentMouseCoordinates[1] <= drawerRect.bottom;

          if (!isInsideDrawer) {
            handlePanelClose();
          }
        }}
      >
        <Logo expanded={expanded} />
        {!isUserDisabled && <NavigationList expanded={expanded} />}
        <Box sx={{ flexGrow: 1 }} />
        <Box
          sx={{
            p: 1,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: 1,
          }}
        >
          <HelpItem expanded={expanded} />
          <OrganizationItem expanded={expanded} />
          <ProfileItem expanded={expanded} />
        </Box>
      </Panel>
    </NavigationPanel>
  );
}
